import * as Sentry from "@sentry/browser";
import { SentryTags } from "@app/services/sentry/SentryTags";

export enum SentryBreadcrumbType {
	APP_EVENT = "app_event",
	GAME_STATE = "game_state",
	DEBUG_INFO = "debug_info",
	USER_ACTION = "user_action"
}
/**
 * Wrapper around basic Sentry functions to expose more handy API + additional typings.
 */
export class SentryWrapper {

	public static addBreadcrumb(type: SentryBreadcrumbType, message: string, data: unknown = undefined) {
		Sentry.addBreadcrumb({
			category: type,
			message: message,
			level: "info",
			data
		});
	}

	public static setTag(tag: keyof SentryTags, value: string | boolean | number) {
		Sentry.setTag(tag, value);
	}

	public static setTags(tags: Partial<SentryTags>) {
		Sentry.setTags(tags);
	}
}